import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { formatDateTime } from "@/lib/price";
import { cn } from "@/lib/utils";
import type { Product } from "@/mocks/products";
import { StatusBadge, statusDescriptions } from "@/components/status-badge";

type CrawlPolicyProps = {
  product: Product;
  className?: string;
};

export function CrawlPolicy({ product, className }: CrawlPolicyProps): JSX.Element {
  const rows = [
    ["Last interval", formatDateTime(product.lastInterestAt)],
    ["Last success", formatDateTime(product.lastSuccessAt)],
    ["Next crawl", formatDateTime(product.nextCrawlAt)],
    ["Total attempts", String(product.interestCount30d + 2)],
  ] as const;

  return (
    <Card className={cn("rounded-lg border-[#20304a] bg-[#071120] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] xl:sticky xl:top-5", className)}>
      <CardHeader className="flex flex-row items-start justify-between gap-3 px-5 pb-1 pt-5">
        <CardTitle className="text-lg font-extrabold text-white">Crawl policy</CardTitle>
        <StatusBadge status={product.crawlStatus} />
      </CardHeader>
      <CardContent className="grid gap-3 px-5 pb-5">
        <div className="grid gap-0 sm:grid-cols-2 xl:grid-cols-1">
          {rows.map(([label, value]) => (
            <div className="grid grid-cols-[1fr_auto] items-center gap-2 py-1.5" key={label}>
              <span className="text-sm font-medium text-[#a5afc2]">{label}</span>
              <strong className="break-words text-right text-sm font-medium tabular-nums text-white">
                {value.replace(",", "")}
              </strong>
              <Separator className="col-span-2 bg-[#20304a]" />
            </div>
          ))}
        </div>
        <div className="rounded-lg border border-[#20304a] bg-[#081323] px-3 py-2.5 text-sm font-extrabold leading-5 text-white">
          <span className="inline-flex items-center gap-2">
            <span className="inline-flex h-5 w-5 items-center justify-center rounded-full border border-[#145f2f] bg-[#082515] text-[#35f36c]">
              ✓
            </span>
            {statusDescriptions[product.crawlStatus]}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
